var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1834 5.8812C12.7833 6.28124 12.5833 6.48127 12.3347 6.48127C12.0862 6.48127 11.8861 6.28124 11.4861 5.8812L10.1212 4.51632C9.72117 4.11627 9.52114 3.91625 9.52114 3.66769C9.52114 3.41913 9.72117 3.21911 10.1212 2.81906L10.3378 2.60248C10.7378 2.20243 10.9379 2.00241 11.1864 2.00241C11.435 2.00241 11.635 2.20243 12.0351 2.60248L13.3999 3.96736C13.8 4.36741 14 4.56743 14 4.81599C14 5.06455 13.8 5.26457 13.3999 5.66462L13.1834 5.8812Z",
    fill: "fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.20014 14.0024C2.63439 14.0024 2.35151 14.0024 2.17576 13.8266C2 13.6509 2 13.368 2 12.8023V11.4374C2 11.1921 2 11.0695 2.04568 10.9592C2.09136 10.8489 2.17808 10.7622 2.35151 10.5887L7.65841 5.28185C8.05846 4.8818 8.25848 4.68178 8.50704 4.68178C8.7556 4.68178 8.95562 4.8818 9.35567 5.28185L10.7205 6.64673C11.1206 7.04678 11.3206 7.2468 11.3206 7.49536C11.3206 7.74392 11.1206 7.94394 10.7205 8.34399L5.41365 13.6509C5.24021 13.8243 5.15349 13.911 5.04322 13.9567C4.93294 14.0024 4.8103 14.0024 4.56502 14.0024H3.20014Z",
    fill: "fill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c152c976d493d1da3be7e2732264e254.svg";
export { ForwardRef as ReactComponent };